import { createAction } from '@poa/state';

export const Countries = {
  UKRAINE: 'Украина',
  RUSSIAN: 'Россия',
  BELARUS: 'Беларусь',
  KAZAKHSTAN: 'Казахстан'
};

export const optionsCounties = [
  {
    label: Countries.UKRAINE,
    value: 'ukraine'
  },
  {
    label: Countries.RUSSIAN,
    value: 'russian'
  },
  {
    label: Countries.BELARUS,
    value: 'belarus'
  },
  {
    label: Countries.KAZAKHSTAN,
    value: 'kazakhstan'
  }
];

export const optionsTypePayment = [
  {
    label: 'Карта',
    value: 'card'
  },
  {
    label: 'Наличные ( только областные центры Украины )',
    value: 'cash'
  },
  {
    label: 'Web Money',
    value: 'web-money'
  },
  {
    label: 'Western Union',
    value: 'western-union'
  }
];

export const setCurrentCountry = createAction('payment/setCurrentCountry', ({ label, value }) => ({
  label,
  value
}));

export const setTypePayment = createAction('payment/setTypePayment', ({ label, value }) => ({
  label,
  value
}));

export const setTypeCard = createAction('payment/setTypeCard', ({ label, value }) => ({
  label,
  value
}));

export const setCard = createAction('payment/setCard', ({ label, value }) => ({
  label,
  value
}));
